import React from "react";
import { Field, Formik } from "formik";
import { object } from "yup";
import { TextField } from "formik-material-ui";
import Button from "@material-ui/core/Button/Button";
import Grid from "@material-ui/core/Grid";

const validationSchema = object().shape({});

const handleSubmitting = (fn) => (values, actions) => {
  fn(values);
  actions.setSubmitting(false);
};

export const EntityMainForm = ({ onSubmit, entity }) => (
  <Formik
    initialValues={{
      id: entity.id,
      name: entity.name,
      main_contact_name: entity.main_contact_name,
      address: entity.address,
      nif: entity.nif,
      postal_code_4: entity.postal_code_4,
      postal_code_3: entity.postal_code_3,
      postal_designation: entity.postal_designation,
      invoicexpress_client_id: entity.invoicexpress_client_id,
      seo_robots: entity.seo_robots,
    }}
    onSubmit={handleSubmitting(onSubmit)}
    validationSchema={validationSchema}
    validateOnChange={false}
    validateOnBlur={false}
    render={({ values, handleSubmit, setFieldValue }) => {
      return (
        <form onSubmit={handleSubmit}>
          <Grid style={{}}>
            <Field
              name="name"
              label="Nome"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.name}
              fullWidth
            />
            {values.name && values.name !== entity.name && (
              <Field
                name="iban"
                label="IBAN"
                type="text"
                variant="outlined"
                margin="normal"
                component={TextField}
                onChange={setFieldValue}
                value={"" + values.iban}
                fullWidth
              />
            )}
            <Field
              name="main_contact_name"
              label="Nome do Responsável"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.main_contact_name}
              fullWidth
            />
            <Field
              name="address"
              label="Morada"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.address}
              fullWidth
            />
            <Field
              name="nif"
              label="NIF"
              type="number"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.nif}
            />
          </Grid>
          <Grid>
            <Field
              name="postal_code_4"
              label="Código Postal (4)"
              type="number"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.postal_code_4}
            />
            <Field
              name="postal_code_3"
              label="Código Postal (3)"
              type="number"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.postal_code_3}
            />
            <Field
              name="postal_designation"
              label="Localidade"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.postal_designation}
            />
          </Grid>
          <Grid>
            <Field
              name="invoicexpress_client_id"
              label="ID InvoiceXpress"
              placeholder="ID InvoiceXpress do cliente"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.invoicexpress_client_id}
              inputProps={{ maxLength: 10 }}
            />
            <Field
              name="seo_robots"
              label="SEO Robots"
              placeholder=""
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={"" + values.seo_robots}
            />
          </Grid>
          <Button
            variant="contained"
            type="submit"
            size="small"
            style={{ marginTop: "20px" }}
          >
            Atualizar
          </Button>
        </form>
      );
    }}
  />
);
